// ============================================================================
// ObservableStore - Base Class for Domain Stores with Caching
// ============================================================================
// Extends EventEmitter with LRU cache and subscription manager.
// Use this when you need caching. Use EventEmitter directly for simpler stores.
// ============================================================================

import { EventEmitter } from './event-emitter.js';
import { CacheStore } from './cache-store.js';
import { globalSubscriptionManager } from './subscription-manager.js';

class ObservableStore extends EventEmitter {
    constructor() {
        super();
        this.cache = new CacheStore();
        this.subscriptions = globalSubscriptionManager;
    }

    destroy() {
        super.destroy();
        this.cache.clear();
    }
}

export { ObservableStore };
